import { combineReducers } from 'redux';
import cartReducers from './cartReducers';
import filterReducers from './filterReducers';

const reducer = combineReducers({
    cart: cartReducers,
    filter: filterReducers,
})

export default reducer;